export default "__VITE_ASSET__BlrlRt_2__"